import { UserCredential } from 'firebase/auth';

export interface AuthenticationUser {
  email: string | null;
  primaryEmail?: string;
  displayName: string | null;
  photoURL: string | null;
}

export interface MicrosoftUserCredential extends UserCredential {
  accessToken: string;
}
